import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BrasilApiService } from '../../services/brasil-api.service';
@Component({
  selector: 'app-modal-dados-bancarios-pdv',
  templateUrl: './modal-dados-bancarios-pdv.component.html',
  styleUrls: ['./modal-dados-bancarios-pdv.component.css']
})
export class ModalDadosBancariosPDVComponent implements OnInit {
  faSquareXmark = faSquareXmark;
  listaBancos: any;
  listaDocumentos: Array<{ fileName: string, evento: any }> = [];
  @Input() lista: any;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  form: FormGroup = new FormGroup({
    nomeBanco: new FormControl(null, [Validators.required]),
    numeroConta: new FormControl(null, [Validators.required]),
    tipoConta: new FormControl(null, [Validators.required]),
    numeroAgencia: new FormControl(null, [Validators.required]),
  });
  constructor(public activeModal: NgbActiveModal, private formBuilder: FormBuilder, private brasilApiService: BrasilApiService) {
    this.listaDocumentos = this.lista;
  }
  ngOnInit(): void {
    this.listaDocumentos = this.lista;
  }
  adicionarArquivos(evento: any) {
    evento.forEach((doc: any) => {
      this.listaDocumentos.push(doc);
    });
    setTimeout(() => {
      this.save();
    }, 200)
  }
  removeFile(position: number) {
    this.listaDocumentos.splice(position, 1);
  }
  save() {
    this.passEntry.emit(this.listaDocumentos);
    this.activeModal.close(this.listaDocumentos);
  }
  createFile(enabled: boolean) {
    return this.formBuilder.group({
      name: new FormControl({ value: 'Comprovante Bancário', disabled: false }),
      file: new FormControl({ value: null, disabled: false }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: false }),
      MD5: new FormControl({ value: null, disabled: false }),
    });
  }
}
